<script lang="ts">
    import { apiBaseOverride } from "../../../store"
    import DefaultImage from "../DefaultImage.svelte"
    import Cta from "./columns/CTA.svelte"
    import Text from "./columns/Text.svelte"

    export let column: BlockColumn

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase
</script>

<section
    class:imageMobileBackground="{column.imageMobileBackground}"
    class="{column.colWidth > 0 ? 'col-md-' + column.colWidth + ' col-12' : 'col-md-auto col-12'}"
    class:align-self-start="{column.verticalAlign == 'top'}"
    class:align-self-center="{column.verticalAlign == 'middle'}"
    class:align-self-end="{column.verticalAlign == 'bottom'}"
>
    {#if column.type == "text"}
        <Text column="{column}" />
    {:else if column.type == "image"}
        <DefaultImage
            images="{column.images}"
            imageHoverEffect="{column.imageHoverEffect}"
        />
    {:else if column.type == "cta"}
        <Cta column="{column}" />
    {/if}
</section>

<style lang="less">
    @import "../../../../lib/assets/css/variables.less";
    section {
        width: 0px;
        flex-grow: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        position: relative;
        z-index: 2;
        @media @mobile {
            &.imageMobileBackground {
                position: absolute;
                bottom: 0px;
                width: 100%;
                height: 100%;
                z-index: 1;
            }
        }
    }
</style>
